// removed by extract-text-webpack-plugin
module.exports = {"container":"_2GgmO","icon":"_2eWEl"};


//////////////////
// WEBPACK FOOTER
// ./app/components/badge/badge.scss
// module id = 835
// module chunks = 3 4 5 6 7